import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styled from 'styled-components';
import { rem } from '../utils/Polished';
import Box from '../Box';
import Typography from '../Typography';
import ButtonText from '../Button/ButtonText';
const SegmentSC = styled.div.attrs({
    role: 'tablist',
    'aria-label': 'Sample Tabs'
}) `
  display: block;

  & > button {
    margin: 0;

    position: relative;
    z-index: ${(p) => p.theme.zIndex.default + 1};

    white-space: nowrap;
    text-overflow: ellipsis;
    max-height: ${(p) => p.theme.SizeHeightSegmentBase};

    border-color: ${(p) => p.theme.ColorBorderSegmentBase};
    border-radius: 0;

    color: ${(p) => p.theme.ColorFontSegmentBase};
    font-weight: ${(p) => p.theme.ContentFontWeightSegmentBase};

    will-change: z-index, font-weight;
    transition: z-index ease 0.3s, font-weight ease 0.3s;
  }

  & > button::before {
    border-radius: 0;
  }

  & > button:hover {
    background-color: transparent;
    color: ${(p) => p.theme.ColorFontSegmentHover};
    border-color: ${(p) => p.theme.ColorBorderSegmentHover};
  }

  & > button._ndsSeg--selected {
    color: ${(p) => p.theme.ColorFontSegmentSelected};
    background-color: ${(p) => p.theme.ColorBackgroundSegmentSelected};
    border-color: ${(p) => p.theme.ColorBorderSegmentSelected};
    font-weight: ${(p) => p.theme.ContentFontWeightSegmentSelected};
  }

  & > button._ndsSeg--selected + button,
  & > button:hover + button {
    border-left-color: ${(p) => p.theme.ColorBorderSegmentSelected};
  }

  & > button:focus,
  & > button:active {
    z-index: ${(p) => p.theme.zIndex.default + 2};
    color: ${(p) => p.theme.ColorFontSegmentActive};
    border-color: ${(p) => p.theme.ColorBorderSegmentActive};
    background-color: transparent;
  }

  & > button._ndsSeg--selected:focus,
  & > button._ndsSeg--selected:active {
    background-color: ${(p) => p.theme.ColorBackgroundSegmentActive};
  }

  &._ndsSeg--2 > button {
    min-width: 50%;
    max-width: 50%;
  }

  &._ndsSeg--3 > button {
    min-width: calc(100% / 3);
    max-width: calc(100% / 3);
  }

  &._ndsSeg--4 > button {
    min-width: 25%;
    max-width: 25%;
  }

  & > button:first-child,
  & > button:first-child::before {
    border-top-left-radius: ${(p) => p.theme.SizeBorderRadiusSegmentBase};
    border-bottom-left-radius: ${(p) => p.theme.SizeBorderRadiusSegmentBase};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  & > button:last-child,
  & > button:last-child::before {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: ${(p) => p.theme.SizeBorderRadiusSegmentBase};
    border-bottom-right-radius: ${(p) => p.theme.SizeBorderRadiusSegmentBase};
  }

  & > button:nth-child(2),
  & > button:nth-child(3),
  & > button:nth-child(4) {
    margin-left: ${rem('-1px')};
  }
`;
const Segment = (props) => {
    const { label, data, selectedIndex: indexProp, onChange } = props;
    const l = data.length;
    const [selectedIndexState, setSelectedIndexState] = React.useState(Number(indexProp));
    const { current: isControlled } = React.useRef(indexProp != null);
    const handleTabClick = React.useCallback((event) => {
        const eventIndex = event.target.dataset.index;
        if (!isControlled) {
            if (eventIndex !== selectedIndexState) {
                setSelectedIndexState(Number(eventIndex));
            }
        }
        if (onChange) {
            onChange(event);
        }
    }, [onChange, selectedIndexState, isControlled]);
    let currentSelected = isControlled ? indexProp : selectedIndexState;
    currentSelected = currentSelected || 0;
    currentSelected = Math.max(0, currentSelected);
    currentSelected = Math.min(data.length - 1, currentSelected);
    const tabs = data.map((tab, index) => {
        const extraProps = {
            key: index,
            role: 'tab',
            'aria-selected': index === currentSelected,
            'aria-label': tab,
            'data-index': index
        };
        return (React.createElement(ButtonText, Object.assign({ onClick: handleTabClick, className: clsx({ '_ndsSeg--selected': index === currentSelected }, `_ndsSegTab__${index + 1}`) }, extraProps), tab));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mb: 1 },
            React.createElement(Typography, { variant: "subhead1" }, label)),
        React.createElement(SegmentSC, { className: `_ndsSeg--${l}` }, tabs)));
};
Segment.propTypes = {
    label: PropTypes.string.isRequired,
    selectedIndex: PropTypes.number,
    data: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
};
Segment.defaultProps = {
    selectedIndex: undefined
};
export { Segment as SegmentRootComp };
export default Segment;
//# sourceMappingURL=Segment.js.map